import { CardHeader } from 'reactstrap'

const SubmissionHeader = (props) => {
  const currentCourseProgress = props.userProgress.find(
    (item) => item.course_id === props.course_id
  )
  let language = props.language || {}
  const handleRetry = () => {
    props.dispatch(props.resetSubmitedContentQuiz())
  }
  return (
    <div className=''>
      <CardHeader style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span className='text-info font-weight-bold'>
          {language.courses ? language.courses.total_points : null}:{' '}
          {(props.submitedContentQuiz &&
            props.submitedContentQuiz.quiz_score) ||
            0}{' '}
          /{' '}
          {props.submitedContentQuiz &&
          props.submitedContentQuiz.quiz &&
          props.submitedContentQuiz.quiz.length
            ? props.submitedContentQuiz.quiz
                .map((item) => parseInt(item.points))
                .reduce((total, value) => total + value) || 0
            : null}
        </span>
        {props.submitedContentQuiz.quiz_passed != 1 ? (
          <button
            className='btn btn-default btn-info submit-button'
            onClick={() => props.dispatch(props.resetSubmitedContentQuiz())}
            // className={`btn btn-default btn-info${
            // 	props.countEnded ? ' disabled' : ''
            // }`}
            // onClick={!props.countEnded ? props.onSubmit : null}
          >
            {'Retry Quiz'}
          </button>
        ) : (
          ''
        )}
      </CardHeader>
      <div className='col-md-10 mt-2'>
        <span
          className='submission-message'
          style={{
            color:
              props.progress_status === 2
                ? '#ff0000'
                : props.progress_status === 3
                ? '#46b943'
                : '#000',
          }}
          dangerouslySetInnerHTML={{
            __html:
              props.submitedContentQuiz &&
              props.submitedContentQuiz.quiz_score_percentage >=
                props.submitedContentQuiz.quiz_pass_percentage
                ? language.courses
                  ? language.courses.success_quiz_message
                  : null
                : props.submitedContentQuiz &&
                  props.submitedContentQuiz.message,
          }}
        />
        <br />

        <div
          className='total-points-mobile-wrapper'
          style={{ textAlign: 'right' }}
        >
          <span className='user-points'>
            {language.courses ? language.courses.total_points : null}:{' '}
            {(props.submitedContentQuiz &&
              props.submitedContentQuiz.quiz_score) ||
              0}{' '}
            /{' '}
            {props.submitedContentQuiz &&
            props.submitedContentQuiz.quiz &&
            props.submitedContentQuiz.quiz.length
              ? props.submitedContentQuiz.quiz
                  .map((item) => parseInt(item.points))
                  .reduce((total, value) => total + value) || 0
              : null}
          </span>
        </div>
      </div>
    </div>
  )
}

export default SubmissionHeader
